<div>
  <div class="modal-window__header">
    <div class="modal-window__title">
      {{ localizationConstants.TECH_COVER_CONTACT_ADD_CONTACT | translate }}
    </div>
    <a (click)="closeDialog(false)">
      <i class="c-icon c-icon--close-dark"></i>
    </a>
  </div>
  <form
    [formGroup]="form"
    id="modal-form"
    class="o-grid--medium u-mt--medium">
    <div class="c-form-group o-grid__item col-12 col-sm-12">
      <label
        for="famCode"
        class="c-form-label"
        >{{ localizationConstants.TECH_COVER_CONTACT_FAM_CODE | translate }}</label
      >
      <mat-select
        [placeholder]="famCodeSelectionPlaceHolder"
        [formControl]="famCodeControl"
        id="famCode"
        name="famCode"
        class="c-user-menu__select c-select c-select--lg">
        <mat-option
          *ngFor="let c of famCodes"
          [value]="c">
          {{ c }}
        </mat-option>
      </mat-select>

      <div
        *ngIf="famCodeControl.touched && famCodeControl.errors?.required"
        class="c-form-alert">
        {{ localizationConstants.TECH_COVER_CONTACT_FAM_CODE_REQUIRED_ERROR | translate }}
      </div>
      <div
        *ngIf="famCodeControl.touched && famCodeControl.errors?.famCode"
        class="c-form-alert">
        {{ localizationConstants.TECH_COVER_CONTACT_FAM_CODE_INVALID | translate }}
      </div>
    </div>
    <div class="c-form-group o-grid__item col-12 col-sm-12">
      <label
        for="email"
        class="c-form-label"
        >{{ localizationConstants.TECH_COVER_CONTACT_EMAIL | translate }}</label
      >
      <input
        id="email"
        name="email"
        [formControl]="emailControl"
        class="c-input c-input--alpha"
        required />
      <div
        *ngIf="emailControl.touched && emailControl.errors?.required"
        class="c-form-alert">
        {{ localizationConstants.TECH_COVER_CONTACT_EMAIL_REQUIRED_ERROR | translate }}
      </div>
      <div
        *ngIf="emailControl.touched && emailControl.errors?.email"
        class="c-form-alert">
        {{ localizationConstants.TECH_COVER_CONTACT_EMAIL_INVALID_ERROR | translate }}
      </div>
      <div
        *ngIf="emailControl.touched && emailControl.errors?.maxlength"
        class="c-form-alert">
        {{
          localizationConstants.VALIDATION_MAX_LENGTH_MESSAGE | translate: { value: maxLengthEmail }
        }}
      </div>
    </div>
    <div class="c-form-group o-grid__item col-12 col-sm-12">
      <label
        for="phone"
        class="c-form-label"
        >{{ localizationConstants.TECH_COVER_CONTACT_PHONE | translate }}</label
      >
      <input
        id="phone"
        name="phone"
        [formControl]="phoneControl"
        class="c-input c-input--alpha" />
      <div
        *ngIf="phoneControl.touched && phoneControl.errors?.required"
        class="c-form-alert">
        {{ localizationConstants.TECH_COVER_CONTACT_PHONE_REQUIRED_ERROR | translate }}
      </div>
      <div
        *ngIf="phoneControl.touched && phoneControl.errors?.maxlength"
        class="c-form-alert">
        {{
          localizationConstants.VALIDATION_MAX_LENGTH_MESSAGE | translate: { value: maxLengthPhone }
        }}
      </div>
    </div>
    <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
      <button
        type="button"
        class="button--sm button-secondary button-block"
        (click)="closeDialog(false)">
        {{ localizationConstants.BUTTON_CANCEL | translate }}
      </button>
    </div>
    <div class="o-grid__item col-12 col-md-3 u-mt--medium">
      <button
        type="button"
        (click)="closeDialog(true)"
        class="button--sm button-primary button-block"
        [disabled]="form.invalid">
        {{ localizationConstants.BUTTON_SAVE | translate }}
      </button>
    </div>
  </form>
</div>
